import $request from '../../utils/request';
var state = {
    cityList: [],
    cityListFull: [],
    signCompanyList: [],
    settleCompanyList: [],
    merchantId: '',
    btnClickOne: 1,
    sendCount: '',
    merchantAccountOpeningInfo: null,
    merchantBankInfoList: null,
    merchantBasicInfo: null,
    merchantOperationInfo: null,
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    GET_COMPANY_ALL: function (_a, _b) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        var type = _b.type, _c = _b.loadingControl, loadingControl = _c === void 0 ? 'auto' : _c;
        $request({
            method: 'post',
            url: '/proxy/api/company/all',
            data: {
                type: type,
            },
            loadingControl: 'hand',
        }).then(function (res) {
            if (!res || res.errorCode) {
                return;
            }
            var data = res.data;
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var temp = data_1[_i];
                temp.key = temp.companyCode;
                temp.val = temp.name;
                temp.label = temp.name;
            }
            var list = [];
            if (data.length > 0) {
                list = data;
            }
            else {
                list = Object.assign([], [
                    {
                        name: '',
                        key: '',
                        clearSelf: type === 'SIGN' ? '_NODATA_SIGN' : type === 'SETTLEMENT' ? '_NODATA_SETTLEMENT' : '',
                    },
                ], data);
            }
            if (type === 'SIGN') {
                commit('update', {
                    signCompanyList: list,
                });
                return;
            }
            if (type === 'SETTLEMENT') {
                commit('update', {
                    settleCompanyList: list,
                });
                return;
            }
        });
    },
    GET_BUSINESSMSG: function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        function clear() {
            commit('update', {
                merchantAccountOpeningInfo: null,
                merchantBankInfoList: null,
                merchantBasicInfo: null,
                merchantOperationInfo: null,
            });
        }
        // 获取商户信息
        $request({
            method: 'post',
            url: '/proxy/api/tenantInfo',
        }).then(function (res) {
            if (!res) {
                clear();
                return;
            }
            if (res.errorCode === 0) {
                var _a = res.data, merchantAccountOpeningInfo = _a.merchantAccountOpeningInfo, merchantBankInfoList = _a.merchantBankInfoList, merchantBasicInfo = _a.merchantBasicInfo, merchantOperationInfo = _a.merchantOperationInfo;
                commit('update', {
                    merchantAccountOpeningInfo: merchantAccountOpeningInfo,
                    merchantBankInfoList: merchantBankInfoList,
                    merchantBasicInfo: merchantBasicInfo,
                    merchantOperationInfo: merchantOperationInfo,
                });
                return;
            }
            clear();
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
